<template>
    <div class="content terms">
        <v-row>
            <v-col class="pa-6 px-10 pa-md-12 pb-2 pb-md-2 d-flex flex-column">
                <h1>{{page.title}}</h1>
                <div class="terms-modified">{{page.lastModified}}</div>
                <p class="terms-content" v-html="page.content"></p>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-6 px-10 pa-md-12 pt-0 pt-md-0 pb-12">
                <AdditionalTerms :page="page" />
            </v-col>
        </v-row>
    </div>
</template>

<script>

    import AdditionalTerms from "../components/AdditionalTerms";
    import SiteService from "../services/site.service";
    import { flattenObj } from '../utils/utils';
export default {
  name: 'Terms',
    data() {
      return {
          page: null
      }
    },
    async beforeMount() {
        const response = await SiteService.getTermsPage();
        this.page = flattenObj(response);
    },
    components: {
        AdditionalTerms
    }
}
</script>

<style scoped>
    .terms h1 {
        font-size: 26px !important;
        font-weight: 700;
    }
    .terms .terms-modified {
        font-size: 14px;
        font-weight: 400;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .terms .terms-content {
        font-size: 14px;
        font-weight: 400;
        font-family: 'Poppins', sans-serif;
    }
</style>
